import React from 'react';
import { usePlaytesterStore } from '../../stores/playtester-store.js';

export function LoseOverlay() {
  const dismissOverlay = usePlaytesterStore((s) => s.dismissOverlay);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70">
      <div className="bg-gray-900 border border-red-700 rounded-xl p-8 flex flex-col items-center gap-6 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center">
          <h2 className="text-red-400 text-3xl font-bold mb-2">Defeated by the Horde</h2>
          <p className="text-gray-400 text-sm">Your life total reached 0.</p>
        </div>

        <div className="flex flex-col gap-3 w-full">
          <button
            onClick={() => dismissOverlay('continue')}
            className="w-full py-3 rounded-lg bg-red-800 hover:bg-red-700 text-white font-semibold text-base transition-colors"
          >
            Acknowledge
          </button>
          <button
            onClick={() => dismissOverlay('continue')}
            className="w-full py-2.5 rounded-lg bg-gray-700 hover:bg-gray-600 text-white font-medium text-sm transition-colors"
          >
            Continue Playing
          </button>
        </div>
      </div>
    </div>
  );
}
